/* Shotlist Info component  */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const InfoShot = () => {
  return (
    <div>
    <Row className="mb-3">
      <Col className="d-none d-md-block" md={2}></Col>     
      <Col xs={12} md={8} >
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <p className={`${styles.Red} text-center`}>INFO</p>
        <hr className={`mt-2 mb-0`}/>
        <p className={`pt-2`}><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Add Shot</span> tab 
        to add Shots to the Shotlist choosing as many of the fields as required.
        </p>
        <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> Use Drag and Drop to <span className={`${styles.Red}`}>Reorder</span> Shots.
        </p>
        <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> A Shot Sketch or Image may be optionally added.
        </p>
        <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> If a Shot is to be <span className={`${styles.Red}`}>Deleted</span> move it to the 
        last position first to keep the automatic ordering correct.
        </p>
        <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> Users who are assigned to work on the Shotlist need to be given 
        the <span className={`${styles.Red}`}>Superadmin Permission</span>, as only Superadmins have Create/Edit/Delete and Reorder access 
        for the Shotlist.
        </p>
        <p className={`${styles.SmallInfo} pt-3`}>
        <span className={`${styles.Red}`}>*</span> Important! Superadmins not assigned to work on the Shotlist should not use the 
        Drag and Drop or delete Shots.
        </p>
        <hr className={`mt-2 mb-0`}/>
        </div>
      </Col>
    </Row>
    </div>
  )
}

export default InfoShot